var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0.166016C7.25996 0.166016 0.166626 7.25935 0.166626 15.9993C0.166626 24.7393 7.25996 31.8327 16 31.8327C24.74 31.8327 31.8333 24.7393 31.8333 15.9993C31.8333 7.25935 24.74 0.166016 16 0.166016ZM16 4.91602C18.6283 4.91602 20.75 7.03768 20.75 9.66602C20.75 12.2943 18.6283 14.416 16 14.416C13.3716 14.416 11.25 12.2943 11.25 9.66602C11.25 7.03768 13.3716 4.91602 16 4.91602ZM16 27.3993C14.1187 27.3994 12.2668 26.9338 10.6091 26.0442C8.95155 25.1547 7.53986 23.8687 6.49996 22.301C6.54746 19.1502 12.8333 17.4243 16 17.4243C19.1508 17.4243 25.4525 19.1502 25.5 22.301C24.4601 23.8687 23.0484 25.1547 21.3908 26.0442C19.7332 26.9338 17.8812 27.3994 16 27.3993Z",
    fill: "#9E31E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.05f6ffd3f412154d9f585e1237bf8e6e.svg";
export { ForwardRef as ReactComponent };